<template lang="pug">
  v-app
    div.uncopyable(id="app" style="width:100%;height: 100%" data-app)
      router-view(v-slot="{}")
    div(v-if="includedOnPages")
      div.navbar-container
        nav-bar
</template>

<script>

import { mapActions } from 'vuex';
import NavBar from './components/app/navBar/NavBar.vue'

window.codeVersion = 1

export default { 
  name:"App",
  mixins:[],

  components: {
    NavBar
  },

  mounted() {
    if(window.location.pathname == "/auth") return
    this.loadUserInfo()
  },

  
  computed: {
    includedOnPages(){
      if(this.showModalWindowFlag && this.$route.name == "MainPage") {
        return false
      }
      let pages = [
        'MainPage',
        'GoalPage',
        'ProfilePage',
        'GpsPage'
      ]
      return pages.indexOf(this.$route.name)===-1? false : true
    }
  },

  methods: {
    ...mapActions('user', ['loadUserInfo'])
  }
  
}
</script>

<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }  
}
.uncopyable{
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.navbar-container {
  z-index: 200;
  bottom: 0px;
  width: 100%;
  height: auto;
  margin: 0px 0px 0px 0px;
  display: flex;
  justify-content: center;
}
</style>
